// 校验特殊字符
// var specialValidate = (rule, value, callback) => {
//   var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
//   if (value.match(reg)) {
//     callback(new Error(window.vm.$t('confirm.donNotEmoticons')));
//   } else {
//     callback();
//   }
// };
export default {
  formRules: {
    salesLadingNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.salesLadingNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    allotNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.allotNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    returnAndChangeNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.returnAndChangeNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    deliveryMethod: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.deliveryMethodPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    outboundCreateTime: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.outboundCreateTimePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    validDateTo: [
      {
        required: false,
        message: window.vm.$t('transportDeliveryOrder.form.validDateToPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    contactPersonName: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.contactPersonPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    contactPhone: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.contactPhonePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    outboundStorageNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.outboundStorageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    // storageContactPhone: [
    //   { required: true, message: window.vm.$t("transportDeliveryOrder.form.storageContactPhonePlaceholder"), trigger: ["change", "blur"] }
    // ],
    outboundType: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.outboundTypePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    customerNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.customerNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    includeOutboundExpenseData: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.fisIncludeOutboundExpensePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
  },
  goodRules: {
    storageShouldSendQuantity: [
      {
        required: true,
        message: window.vm.$t(
          'transportDeliveryOrder.form.good.storageShouldSendQuantityPlaceholder'
        ),
        trigger: ['change', 'blur'],
      },
    ],
    storageSendQuantity: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.good.storageSendQuantityPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ], //仓库实发数量
  },
  feeRules: {
    expenseType: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.outboundExpense.expenseTypePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    expenseRate: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.outboundExpense.expenseRatePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    outboundQuantity: [
      {
        required: true,
        message: window.vm.$t(
          'transportDeliveryOrder.form.outboundExpense.outboundQuantityPlaceholder'
        ),
        trigger: ['change', 'blur'],
      },
    ],
    outboundExpense: [
      {
        required: true,
        message: window.vm.$t(
          'transportDeliveryOrder.form.outboundExpense.outboundExpensePlaceholder'
        ),
        trigger: ['change', 'blur'],
      },
    ],
  },
  transportRules: {
    nameVoyageLicense: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.transport.nameVoyageLicensePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    contactPerson: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.transport.contactPersonPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    contactPhoneNo: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.transport.contactPhoneNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
  },
  sendMessage: {
    sendPhone: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.sendMessage.contactPhonePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    sendMsg: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.sendMessage.content'),
        trigger: ['change', 'blur'],
      },
    ],
  },
  sendEmail: {
    recipient: [
      {
        required: true,
        message: window.vm.$t('transportDeliveryOrder.form.sendEmailPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
  },
};
